<template>
  <div class="d-flex flex-column flex-grow-1 container-fluid" v-if="matrix">
    <div class="d-flex align-items-center my-2">
      <back-button class="mr-2" to="/settings/matrices"/>
      <div class="input-group mr-auto name-input">
        <input type="text" class="form-control" v-model="matrix.name">
      </div>
      <button class="btn btn-primary mr-2" @click="addProduct">Добавить продукт</button>
      <btn-action class="btn btn-primary mr-2" @click="save" v-if="$root.checkPermission('web_matrix_edit')">Сохранить</btn-action>
    </div>
    <div class="table-full-width flex-grow-1 bg-white d-flex flex-column">
      <table class="table mb-0">
        <thead>
        <tr><th>
          <span class="mr-3" style="min-width: 2em">№</span>
          <span>Продукты</span>
        </th></tr>
        </thead>
      </table>

      <height-tracker class="container-fluid flex-grow-1">
        <div class="table-full-width" slot-scope="{ height }">
          <div ref='content' :style="'overflow-y: auto; height: ' + height + 'px'">
            <draggable v-model="matrix.products">
              <div v-for="(element, index) in matrix.products">
                <div class="d-flex flex-row p-2 washy-bottom">
                  <div class="form-group mr-3" style="max-width: 5em">
                    <input type="text" class="form-control" v-model="numbers[index]">
                  </div>
                    <div>{{element.product.name}}</div>
                  <div class="ml-auto text-nowrap">
                    <button @click="remove(index)" class="btn btn-sm btn-outline-light">Удалить</button>
                  </div>
                </div>
              </div>
            </draggable>
            <slot/>
          </div>
        </div>
      </height-tracker>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import productModal from '../../../components/matrices/product-modal.vue'
  import draggable from 'vuedraggable'

  export default {
    components: {
      draggable,
    },
    props: ['id'],
    data () {
      return {
        isCopy: !!this.$route.query.copy,
        numbers: [],
      }
    },
    methods: {
      addProduct () {
        this.$root.showModal(productModal).then((data) => {
          if (data) {
            this.matrix.products.push({
              product: data,
              product_id: data.id,
            })
            this.numbers.push(this.numbers.length + 1)
          }
        })
      },
      remove (index) {
        this.matrix.products.splice(index, 1)
        this.numbers.splice(index, 1)
      },
      save () {
        const data = {
          name: this.matrix.name,
          products: this.matrix.products.map((product) => {
            return {
              product_id: product.product_id,
            }
          }),
          product_numbers: this.numbers,
        }
        if (this.id && !this.isCopy) {
          api.put(`matrix/${this.id}`, data)
            .then(() => this.$router.push(`/settings/matrices`))
        } else {
          api.post('matrix', data).then((response) => {
            this.$router.push(`/settings/matrices`)
          })
        }
      },
    },
    asyncComputed: {
      matrix () {
        if (this.id) {
          return api
            .get(`matrix/${this.id}`)
            .then(({data}) => {
              if (this.isCopy) {
                data.data.name += ' Копия'
              }
              this.numbers = data.data.product_numbers
              return data.data
            })
        } else {
          return {
            name: 'Новая матрица',
            products: [],
          }
        }
      },
    },
  }
</script>

<style lang="scss">
  .name-input {
    max-width: 30em;
  }
  .washy-bottom {
    border-bottom: 1px solid #E9F2F6;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/matrices/_id.vue